import { IconButton, Close16, UIHeading2, UIText3 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './InfrastructureMapYearsService.css';
import { Year } from './parts/Year';

interface IYearsServiceProps {
  selectedYear: number;
  nextAvailableYear: number | null;
  years: number[];
  onChange: (value: number) => void;
  onClose: () => void;
}

export const InfrastructureMapYearsService: React.FC<IYearsServiceProps> = ({
  selectedYear,
  nextAvailableYear,
  years,
  onChange,
  onClose,
}) => {
  return (
    <div className={styles['wrapper']} data-testid="InfrastructureMapYearsService">
      <div className={styles['close-button']} aria-label="Закрыть">
        <IconButton icon={<Close16 />} onClick={onClose} />
      </div>
      <UIHeading2>Развитие инфраструктуры</UIHeading2>
      <div className={styles['warning']}>
        <UIText3 color="gray60_100">Данные могут быть неточными</UIText3>
      </div>
      <div className={styles['years']}>
        {years.map(year => (
          <Year
            key={year}
            year={year}
            onChange={onChange}
            checked={year === selectedYear}
            nextAvailableYear={nextAvailableYear}
          />
        ))}
      </div>
    </div>
  );
};
